import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreamByRequestUid,
} from 'widgets/WidgetRegistry';
import State from 'store/State';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { OrderColumns } from 'communication/types/order/Order';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { VolumeCapsule } from 'widgets/liquiditySummary/volumeCapsule/components/VolumeCapsule';
import { VolumeCapsuleConfigState } from 'widgets/liquiditySummary/volumeCapsule/state/config/VolumeCapsuleConfigState';
import { buildVolumeCapsuleConfigSlice } from 'widgets/liquiditySummary/volumeCapsule/state/config/configslice';
import { volumeCapsuleDescription } from 'widgets/liquiditySummary/volumeCapsule/components/description/volumeCapsuleDescription';
import { LiquidityStreamRequest } from 'widgets/liquiditySummary/api/LiquiditySummaryStreamRequest';
import { liquidityStreamConfig } from 'widgets/liquiditySummary/store/data/stream-config';
import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import React from 'react';
import VolumeCapsuleSettings from 'widgets/liquiditySummary/volumeCapsule/components/settings/VolumeCapsuleSettings';
import { liquidityStreamedDataSelectors } from 'widgets/liquiditySummary/store/data/streamSlice';
import { VolumeCapsuleMyPortfolioCapsuleContent } from 'widgets/liquiditySummary/volumeCapsule/components/VolumeCapsuleMyPortfolioCapsuleContent';

const { useStreamedDataMessages } = liquidityStreamedDataSelectors;

const { initialConfigState } = buildVolumeCapsuleConfigSlice();

const useMessagesInMyPortfolioCapsules = (
    symbol: string,
    _symbology: SymbologyValues,
    qty?: number
) => useStreamedDataMessages(symbol, initialConfigState, qty);

export const volumeCapsuleWidgetStrategy: MyPortfolioCapsuleWidgetStrategyWithConfig<VolumeCapsuleConfigState> &
    WidgetStrategyWithConfig<VolumeCapsuleConfigState> &
    WidgetStrategyWithStreamByRequestUid<LiquidityStreamRequest> = {
    title: 'Volume',
    supportedHosts: ['tile'],
    reactComponentType: VolumeCapsule,
    getRequiredOrderColumns,
    categories: [WidgetCategory.VOLUME_CAPSULES],
    description: volumeCapsuleDescription,
    managedStreamConfig: liquidityStreamConfig,
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.SingleSymbolQuantity,
    initialConfigState,
    supportsMyPortfolioCapsule: true,
    supportsMyPortfolioCapsuleConfig: true,
    myPortfolioCapsuleContentReactComponentType:
        VolumeCapsuleMyPortfolioCapsuleContent,
    renderSettingsBody,
    useMessagesInMyPortfolioCapsules,
};

function renderSettingsBody(
    config: VolumeCapsuleConfigState,
    onChange: (configDelta: Partial<VolumeCapsuleConfigState>) => void
) {
    return <VolumeCapsuleSettings config={config} onChange={onChange} />;
}

function getRequiredOrderColumns(
    _state: State,
    _widgetId: string,
    _symbology: SymbologyValues
): OrderColumns {
    return ['rem'];
}
